export const SET_PROPERTY_PRODUCT = "SET_PROPERTY_PRODUCT";
export const PRODUCTS_RECEIVED = "PRODUCTS_RECEIVED";
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const SET_PRODUCT = "SET_PRODUCT";
